import 'rxjs/add/operator/debounceTime';
import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {ProfileService} from "../../../providers/profile-service";
import {ProfileRepository} from "../../../repositories/profile-repository";
import {HotspotService} from "../../../providers/hotspot-service";

@Component({
    selector: 'page-webstor-evento-tipo',
    templateUrl: 'webstor-evento-tipo.html',
    providers: [ProfileService, ProfileRepository, HotspotService]
})
export class WebstorEventoTipoPage {

    config: any;
    logado: any;
    perfil: any;

    hotspot: any;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public util: Util,
                public logadoService: LogadoService,
                public profileService: ProfileService, public profileRepository: ProfileRepository,
                public hotspotService: HotspotService) {


        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Webstor Evento Tipo', '/webstor-evento-tipo');

        //this.load(this.navParams.get('hotspotID'));

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

    load(hotspotID) {


    }

    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/webstor-evento-tipo/webstor-evento-tipo.ts